import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import { createProgram } from "store/programBuilder/actionCreator";
import { useNavigate } from "react-router-dom";
import { SaveOrEditProgramForm } from "./modals/EditProgramDetailsModal";
import isEmpty from "lodash/isEmpty";
import { api } from "store/slices/api";
import { toast } from "react-toastify";
import "./style.scss";

const defaultExpirationDate = () => {
  let tempDate = new Date();
  tempDate.setDate(tempDate.getDate() + 90);
  return tempDate.toISOString().substring(0, 10);
};

const CreateProgram = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sub = useSelector((state) => state.loggedInUser.sub);
  const { data: employee } = api.useGetEmployeeQuery(sub);

  const [programDetails, setProgramDetails] = useState({
    customerName: "",
    description: "",
    parentName: "",
    parentNumber: "",
    customerLogo: "",
    isCoverLetterAdded: false,
    coverLetterTitle: "Multi-Market Floorcovering Program",
    toData: "",
    expirationDate: defaultExpirationDate(),
    customerLogo: "",
  });

  useEffect(() => {
    setProgramDetails({
      ...programDetails,
      fromUserName: employee?.firstname && employee?.lastname ? `${employee?.firstname} ${employee?.lastname}` : "",
      fromUserTitle: employee?.jobTitle,
      fromUserEmail: employee?.email,
      fromUserPhoneNumber: employee?.phone,
    });
  }, [employee]);

  let submitDisabled =
    [
      programDetails.customerName,
      programDetails.description,
      programDetails.expirationDate,
      programDetails.fromUserName,
      programDetails.fromUserTitle,
      programDetails.fromUserEmail,
      programDetails.fromUserPhoneNumber,
    ].some(isEmpty) ||
    (programDetails.isCoverLetterAdded
      ? [programDetails.coverLetterTitle, programDetails.toData].some(isEmpty)
      : false);

  return (
    <div className="container-fluid search-form-container">
      <div className="search-form-container__title d-flex justify-content-between align-items-center flex-column flex-md-row align-items-md-center">
        <span className="search-form-container__title--text mb-4 mb-md-0">Create New Program</span>
      </div>
      <SaveOrEditProgramForm programDetails={programDetails} setProgramDetails={setProgramDetails} />
      <div className="d-flex footer_display justify-content-between flex-column-reverse flex-md-row">
        <Button variant="outline-primary" onClick={() => navigate("/programBuilder")}>
          Back to search
        </Button>
        <Button
          disabled={submitDisabled}
          onClick={() => {
            const createProgramPromise = dispatch(
              createProgram({ createdBy: sub, ...programDetails, sortByMarket: false, productPricesCarryover: true }),
            );

            toast
              .promise(createProgramPromise, {
                pending: "Creating program",
                success: "Successfully created a program",
                error: "Could not create a program, please try again.",
              })
              .then((res) => navigate(`/programBuilder/programDetails/${res.programId}`));
          }}
        >
          Create Program
        </Button>
      </div>
    </div>
  );
};

export default CreateProgram;
